module.exports = __webpack_public_path__ + "img/abacus_type_demo_2.0a721f8e.png";